import baseEditForm from 'formiojs/components/_classes/component/Component.form';
import FileEditData from 'formiojs/components/file/editForm/File.edit.data';
import FileEditDisplay from 'formiojs/components/file/editForm/File.edit.display';
import FileEditValidation from 'formiojs/components/file/editForm/File.edit.validation';

export default (...extend) => baseEditForm(
  [
    {
      key: 'display',
      components: FileEditDisplay,
    },
    {
      key: 'data',
      components: FileEditData,
    },
    {
      label: 'File',
      key: 'file',
      weight: 5,
      components: [
        {
          type: 'select',
          data: {
            values: [
              { value: 'DamagePicture', label: 'Damage Picture' },
              { value: 'TripMap', label: 'Trip Map' },
              { value: 'PoliceReport', label: 'Police Report' },
              { value: 'PoliceReports', label: 'Police Reports' },
              { value: 'CrashSummaryReport', label: 'Crash Summary Report' },
              { value: 'InsurancePolicy', label: 'Insurance Policy' },
              { value: 'VehicleRegistration', label: 'Vehicle Registration' },
              { value: 'Contract/Lease', label: 'Contract/Lease' },
              { value: 'DriverLicense', label: 'Driver License' },
              { value: 'DriverID', label: 'Driver ID' },
              { value: 'RepairEstimate', label: 'Repair Estimate' },
              { value: 'MedicalBill', label: 'Medical Bill' },
              { value: 'MedicalReport', label: 'Medical Report' },
              { value: 'AudioRecording', label: 'Audio Recording' },
              { value: 'VideoRecording', label: 'Video Recording' },
              { value: 'SupportingDocument', label: 'Supporting Document' },
              { value: 'Other', label: 'Other' },
              { value: 'TPDriverLicense', label: 'TP Driver License' },
              { value: 'TowProvider', label: 'Tow Provider' },
              { value: 'Invoice', label: 'Invoice' },
              { value: 'PoliceReports', label: 'Police Reports' },
              { value: 'TPInsuranceInfo', label: 'TP Insurance Info' },
              { value: 'ScenePhotos', label: 'Scene Photos' },
              { value: 'VehicleDamage', label: 'Vehicle Damage' },
              { value: 'ClaimsNotice', label: 'Claims Notice' },
              { value: 'ClaimsNotice-DigitalFnolSnapshot', label: 'Claims Notice - Digital Fnol Snapshot' },
              { value: 'AmbulanceInvoice', label: 'Ambulance Invoice' },
              { value: 'MedicalReceipts', label: 'Medical Receipts' },
              { value: 'DoctorNote', label: 'Doctor Note' },
              { value: 'DoctorsNote', label: 'Doctors Note' },
              { value: 'NoticeLetter', label: 'Notice Letter' },
              { value: 'StatementOfClaim', label: 'Statement Of Claim' },
              { value: 'Photos', label: 'Photos' },
              { value: 'FireDepartmentReport', label: 'Fire Department Report' },
              { value: 'Estimate/Invoices', label: 'Estimate/Invoices' },
              { value: 'ContentList', label: 'Content List' },
              { value: 'Content-Receipts', label: 'Content - Receipts' },
              { value: 'CondoBylaws', label: 'Condo Bylaws' },
              { value: 'CondoDeclaration/Insurance', label: 'Condo Declaration/Insurance' },
              { value: 'CondoDeclaration', label: 'Condo Declaration' },
            ],
          },
          input: true,
          dataSrc: 'values',
          template: '<span>{{ item.label }}</span>',
          defaultValue: 'DamagePicture',
          label: 'Type of Files',
          weight: 999,
          key: 'typeOfFiles',
          placeholder: 'e.g. DamagePicture',
        },
        {
          type: 'textfield',
          input: true,
          label: 'File Pattern',
          weight: 12,
          key: 'filePattern',
          defaultValue: '.3g2,.3gp,.avi,.m2v,.m4v,.mov,.mp3,.mp4,.mpeg,.mpg,.wav,.wma,.wmv,.264,.amr,.ape,.cda,.dav,.h264,.mht,.mid,.midi,.mnm4,.m4a,.nvf,.wv,.ts,.csv,.doc,.docx,.pdf,.tif,.tiff,.txt,.xls,.xlsx,.ai,.eml,.htm,.html,.json,.msg,.pages,.ppt,.xml,.vsd,.pptx,.rtf,.bmp,.heic,.heif,.m4a,.webp,.gif,.jpeg,.jpg,.png',
          placeholder: '.jpg,.docx,image/jpeg,image/png',
        },
        {
          type: 'textfield',
          input: true,
          label: 'File Minimum Size',
          weight: 12,
          key: 'fileMinimumSize',
          placeholder: 'e.g. 10KB',
          defaultValue: '0Bytes',
        },
        {
          type: 'textfield',
          input: true,
          label: 'File Maximum Size',
          weight: 12,
          key: 'fileMaximumSize',
          placeholder: 'e.g. 20MB',
          defaultValue: '25MB',
        },
        {
          type: 'textfield',
          input: true,
          label: 'Maximum accepted number of files',
          weight: 12,
          key: 'maxFiles',
          placeholder: 'e.g. 5',
          defaultValue: '10',
        },
        {
          type: 'textfield',
          input: true,
          label: 'Global Error Message',
          weight: 12,
          key: 'globalErrorMessage',
          placeholder: 'e.g. Encountered some issues',
          defaultValue: "Hmm! There seems to be an issue with one or more files. Please select the 'x' to remove it and try uploading again.",
        },
        {
          type: 'textfield',
          input: true,
          label: 'Max Files Error Message',
          weight: 15,
          key: 'maxFilesErrorMessage',
          placeholder: 'e.g. Encountered some issues',
          defaultValue: 'Uh oh! The limit of 10 files had been reached.',
        },
        {
          type: 'textfield',
          input: true,
          label: 'Max Files Modal Error Message',
          weight: 12,
          key: 'maxFilesModalErrorMessage',
          placeholder: 'e.g. Encountered some issues',
          defaultValue: "Sorry, you've reached the maximum number of uploads for this section. You can upload a maximum of 10 files.",
        },
      ],
    },
    {
      key: 'validation',
      components: FileEditValidation,
    },
    {
      key: 'addons',
      ignore: true,
    },
    {
      label: 'Custom',
      key: 'custom',
      components: [
        {
          weight: 3000,
          type: 'checkbox',
          label: 'Hide Custom Label',
          tooltip: 'Hide the label (title, if no label) of this component. This allows you to show/hide the custom label when it is rendered.',
          key: 'hideCustomLabel',
          input: true,
        },
        {
          weight: 3000,
          type: 'checkbox',
          label: 'Enter manually option',
          key: 'enterManually',
          input: true,
        },
        {
          type: 'textfield',
          input: true,
          label: 'Enter manually section title',
          weight: 12,
          key: 'enterManuallyTitle',
        },
        {
          type: 'textfield',
          input: true,
          label: 'Enter manually section container key',
          weight: 12,
          key: 'enterManuallyContainer',
        },
      ],
    },
  ],

  ...extend,
);
